import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';


const Success = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    const email = urlParams.get('email');

    console.log(token);

    if (token && email) {
      try {
       

       

        // Set session values
        sessionStorage.setItem('access_token', token);
        sessionStorage.setItem('role', 'user');
        sessionStorage.setItem('email', email);

        // Redirect to /leads
        navigate('/leads');
      } catch (error) {
       
       
      }
    } else {
      
    }
  }, [navigate]);

  return <p>Processing login...</p>;
};

export default Success;
